import React from 'react';
import { Result, Button, Typography, Card, Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const { Text, Title, Paragraph } = Typography;

const EnvironmentError: React.FC = () => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

  return (
    <div style={{ padding: '50px', maxWidth: '800px', margin: '0 auto' }}>
      <Result
        status="warning"
        title="환경 변수 설정 필요"
        subTitle="Supabase 연결을 위한 환경 변수가 설정되지 않았습니다."
        icon={<WarningOutlined style={{ color: '#faad14' }} />}
        extra={
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card title="현재 환경 변수 상태" type="inner">
              <Space direction="vertical" style={{ width: '100%' }}>
                <div>
                  <Text strong>REACT_APP_SUPABASE_URL: </Text>
                  <Text code>{supabaseUrl || '(설정되지 않음)'}</Text>
                </div>
                <div>
                  <Text strong>REACT_APP_SUPABASE_ANON_KEY: </Text>
                  <Text code>{supabaseKey ? '설정됨' : '(설정되지 않음)'}</Text>
                </div>
              </Space>
            </Card>

            <Card title="Vercel에서 환경 변수 설정하기" type="inner">
              <ol>
                <li>Vercel 대시보드로 이동</li>
                <li>프로젝트 선택 → Settings → Environment Variables</li>
                <li>다음 변수 추가:
                  <ul>
                    <li><Text code>REACT_APP_SUPABASE_URL</Text></li>
                    <li><Text code>REACT_APP_SUPABASE_ANON_KEY</Text></li>
                  </ul>
                </li>
                <li>모든 환경(Production, Preview, Development) 선택</li>
                <li>저장 후 <Text strong>반드시 재배포</Text></li>
              </ol>
            </Card>

            <Card title="재배포 방법" type="inner">
              <ol>
                <li>Deployments 탭으로 이동</li>
                <li>최신 배포의 점 3개 메뉴 클릭</li>
                <li>"Redeploy" 선택</li>
                <li><Text strong>"Use existing Build Cache" 체크 해제</Text></li>
                <li>Redeploy 버튼 클릭</li>
              </ol>
            </Card>

            <Button 
              type="primary" 
              onClick={() => window.location.reload()}
              style={{ marginTop: 16 }}
            >
              페이지 새로고침
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default EnvironmentError;